import { render, staticRenderFns } from "./InvoiceTables.vue?vue&type=template&id=3dda5dda&"
import script from "./InvoiceTables.vue?vue&type=script&lang=js&"
export * from "./InvoiceTables.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports